/**
 * One-off reduced-hours notice for the 2026 holiday period (P-2575).
 * Visible through Aug 21 2026; hidden from Aug 22 00:00 Europe/Madrid.
 * August in Spain is CEST (UTC+2), so the cutoff is pinned as a fixed UTC
 * instant — correct regardless of the viewer's system timezone.
 *
 * Remove this module, its test, the `Footer.summerSchedule` key and the
 * conditional in `footer.tsx` once the window has closed.
 */
export const SUMMER_SCHEDULE_ENDS_AT = new Date("2026-08-21T22:00:00Z");

export const isSummerScheduleActive = (now: Date = new Date()): boolean =>
  now < SUMMER_SCHEDULE_ENDS_AT;
